module.exports = __webpack_public_path__ + "img/control-1@2x.a52ca94.jpg";